<template>
  <v-container fluid>
    <!-- <v-tour :options="myOptions" name="myTour" :steps="steps"></v-tour> -->
    <v-dialog v-model="this.$store.getters['Auth/isPpmDone']" persistent>

    </v-dialog>
    <v-select :items="search" label="Filtre d’affichage des Plans de Passation des Marchés par année" filled id="v-step-2"
      v-model="defaultYear" v-on:change="onChange"></v-select>
    <v-data-table :headers="headers" @click:row="handleClick" item-key="this.$store.getters['Auth/getListPpm'].title"
      no-data-text="Aucun Plan de passation disponible" :items="this.$store.getters['Auth/getListPpm']"
      class="elevation-1 mb-5 px-5 pt-1">
      <template v-slot:[`item.publishDate`]="{ item }">{{
        item.publishDate | moment("YYYY")
      }}</template>
      <template v-slot:[`item.valid`]="{ item }">
        <v-chip label small outlined :color="`${item.valid ? 'green' : 'red'}`">
          {{ formatValid(item.valid) }}
        </v-chip>
      </template>
      <template v-slot:[`item.active`]="{ item }">
        <v-icon medium color="green darken-2" v-if="item.active">mdi-circle</v-icon>
      </template>
      <!-- <template v-slot:[`item.revision_status`]="{ item }">
          <v-icon medium color="green darken-2" v-if="item.revision_status">mdi-circle</v-icon>
        </template> -->

        <template v-slot:[`item.revisionStatus`]="{ item }">
          <v-chip v-if="isValidPPM(item)" label small outlined :color="`${item.revisionStatus ? 'green' : 'red'}`">
            {{ formatRevision(item.revisionStatus) }}
          </v-chip>
          <span v-else>---</span>
        </template>
        
        <template v-slot:[`item.ppmFileList.valid`]="{ item }">
          <v-chip v-if="isValidPPM(item) && item.revisionStatus" label small outlined :color="`${item.ppmFileList && item.ppmFileList.length > 0 ? (item.ppmFileList[item.ppmFileList.length - 1].valid ? 'green' : 'red') : 'red'}`">
            {{ formatRevisionValid(item.ppmFileList && item.ppmFileList.length > 0 ? item.ppmFileList[item.ppmFileList.length - 1].valid : false) }}
          </v-chip>
          <span v-else>---</span>
        </template>
        
      
      <template v-slot:top>
        <v-toolbar flat color="white" class="mb-5">
          <v-toolbar-title id="v-step-1" v-show="$vuetify.breakpoint.mdAndUp">Liste détaillée des plans de passation des
            marchés</v-toolbar-title>
          <v-divider class="mx-4" inset vertical v-show="$vuetify.breakpoint.mdAndUp"></v-divider>
          <v-spacer v-show="$vuetify.breakpoint.mdAndUp"></v-spacer>
        </v-toolbar>
      </template>
    </v-data-table>
  </v-container>
</template>
  
<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    myOptions: {
      useKeyboardNavigation: true,
      labels: {
        buttonSkip: "Quitter",
        buttonPrevious: "Precedant",
        buttonNext: "Suivant",
        buttonStop: "Terminer"
      }
    },
    steps: [
      {
        target: "#v-step-0", // We're using document.querySelector() under the hood
        header: {
          title: "Créer un plan de passation"
        },
        content: `La réalisation des objectifs du projet dépend largement des travaux en amont du projet, c’est-à-dire durant les phases de conception et de planification. L’emprunteur devrait consolider, pendant la préparation du projet, tous les accords conclus avec la Banque en matière d’acquisition de biens, travaux et services en un seul document appelé Plan de passation des marchés.`
      },
      {
        target: "#v-step-1",
        content:
          "Tous les plans de passations créer apparaitrons sur cette liste - Vous pouvez y voir plus et cliquant sur la ligne souhaité"
      },
      {
        target: "#v-step-2",
        content: "Automatiquement séléctionné - Vous pouvez de même filtrer l&apos;année cilble"
      }
    ],
    defaultYear: new Date().getFullYear(),
    search: [new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1],
    publishDate: "",
    items: [
      {
        text: "Tableau de bord",
        disabled: false,
        href: "/dashboard"
      },
      {
        text: "Plan de passation des marchés",
        disabled: true
      }
    ],
    dog: true,
    ppm: {
      title: "",
      description: "",
      file: []
    },
    dialog: false,
    headers: [
      {
        text: "Référence des Plans de Passation des Marchés publiée (Initial/révisé)",
        shortable: true,
        value: "title"
      },
      {
        text: "Nombre de Plans de Passation des Marchés révisé",
        align: "start",
        filterable: false,
        value: "revision_size"
      },
      {
        text: "Titre des Plans de Passation des Marchés",
        value: "description",
        sortable: false,
        filterable: false
      },
      { text: "Année de publication des Plans de Passation des Marchés", value: "publishDate", sortable: true },

      {
        text: "Status",
        sortable: false,
        filterable: false,
        value: "valid",
        align: "center",
        formatValid: (value) => (value ? "validé" : "non validé")
      },
      {
        text: "Revisé",
        sortable: false,
        filterable: false,
        value: "revisionStatus",
        align: "center",
        formatRevision: (value) => (value ? "oui" : "non")
      },
      {
        text: "Status du Revisé",
        sortable: false,
        filterable: false,
        value: "ppmFileList.valid",
        align: "center",
        formatRevisionValid: (value) => (value ? "validé" : "non validé")
      },

    ]
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nouveau Plan de passation des marches"
        : "Création du Plan de Passation des Marchés";
    }
  },
  created() {
    const cur_year = new Date().getFullYear();
    this.$store.dispatch("Auth/loadAllPPM", cur_year);

    console.log("Contenu de 'Auth/getListPpm' : ", this.$store.getters['Auth/getListPpm']);

  },
  mounted: function () {
    this.$tours["myTour"].start();
  },
  methods: {
    ...mapActions({
      addPPM: "Auth/addPPM",
      loadAllPPM: "Auth/loadAllPPM",
      getPPM: "Auth/getPPM"
    }),
    formatValid(value) {
      return this.headers.find(header => header.value === "valid").formatValid(value);
    },

    formatRevision(value) {
      return this.headers.find(header => header.value === "revisionStatus").formatRevision(value);
    },

    formatRevisionValid(value) {
      return this.headers.find(header => header.value === "ppmFileList.valid").formatRevisionValid(value);
    },

    isValidPPM(item) {
    return item.valid;
  },

    onChange(e) {
      this.$store.dispatch("Auth/loadAllPPM", e);
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search) !== -1
      );
    },
    close_ppm() {
      this.$store.commit("Auth/CLOSE_PPM", false);
    },
    open_ppm() {
      console.log(this.$store.getters["Auth/isPpmDone"]);
      this.$store.commit("Auth/CLOSE_PPM", true);
    },
    addthisPPM() {
      const data = new FormData();
      data.append("title", this.ppm.title);
      data.append("description", this.ppm.description);
      if (this.ppm.file) {
        data.append("file", this.ppm.file[0]);
      } else {
        data.append("file", null);
      }
      this.addPPM(data);

      (this.ppm.title = ""), (this.ppm.description = ""), (this.ppm.file = []);
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.desserts.splice(index, 1);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    handleClick(value) {
      const { id } = value;
      this.$router.push({ name: "showPpmAno", params: { id } });
      // this.viewDetails(value);
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
  